import { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";

import PatientsPagination from "../PatientsPagination/PatientsPagination";
import { Skeleton } from "@mui/material";
import { setSelectedService } from "@/store/service/service";
import { setIsVisibleModalDialog } from "@/store/ui/ui";

import { IServicesControlsProps } from "@/shared/interfaces/schedulePage";

import "./ServicesListing.scss";

export default function ServicesListing({
    data,
    dataLength,
    category,
    isLoading,
    query,
    toggleDrawer,
}: IServicesControlsProps) {
    const dispatch = useDispatch();
    const [activepage, setActivePage] = useState<number>(1);
    const limitPage = 12;
    const startIndex = (activepage - 1) * limitPage;
    const endIndex = startIndex + limitPage;
    const allData = (data ?? []).slice(startIndex, endIndex);
    const prevQueryRef = useRef<string | undefined>(undefined);

    function handleChangeActivepage(
        event: React.ChangeEvent<unknown>,
        value: number,
    ) {
        setActivePage(value);
    }

    function handleClickEdit(e: React.MouseEvent<HTMLButtonElement>) {
        const target = e.target as HTMLButtonElement;
        toggleDrawer(true);
        dispatch(setSelectedService(target.id));
    }

    async function handleClickDelete(e: React.MouseEvent<HTMLButtonElement>) {
        const target = e.target as HTMLButtonElement;
        dispatch(setSelectedService(target.id));
        dispatch(setIsVisibleModalDialog(true));
    }

    useEffect(() => {
        const currentLength = query?.length ?? 0;

        if (currentLength > 0 && query !== prevQueryRef.current) {
            setActivePage(1);
        }

        prevQueryRef.current = query;
    }, [query]);

    return (
        <main className='main_content_container'>
            <table className='listing_table table_service'>
                <thead>
                    <tr>
                        <th className='listing_table-service_title'>
                            Назва послуги
                        </th>
                        <th className='listing_table-date' id='service_item'>
                            Категорія
                        </th>
                        <th id='service_item'>Вартість</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {isLoading ? (
                        Array.from({ length: 10 }).map((_, index) => (
                            <tr
                                key={index}
                                className='listing_table-row'
                                id='formula_row'
                            >
                                <td
                                    className='listing_table-service_title'
                                    id='service_item'
                                >
                                    <Skeleton
                                        variant='text'
                                        height={34}
                                        style={{
                                            padding: 8,
                                            maxWidth: "93%",
                                            margin: "auto",
                                        }}
                                    />
                                </td>
                                <td id='service_item' className='category_item'>
                                    <Skeleton
                                        variant='text'
                                        height={34}
                                        style={{
                                            padding: 8,
                                            maxWidth: "80%",
                                            margin: "auto",
                                        }}
                                    />
                                </td>
                                <td id='service_item' className='price_item'>
                                    <Skeleton
                                        variant='text'
                                        height={34}
                                        style={{
                                            padding: 8,
                                            maxWidth: "60%",
                                            margin: "auto",
                                        }}
                                    />
                                </td>
                                <td className='button_item'>
                                    <Skeleton
                                        variant='text'
                                        height={34}
                                        style={{
                                            padding: 8,
                                            maxWidth: "40%",
                                            margin: "auto",
                                        }}
                                    />
                                </td>
                            </tr>
                        ))
                    ) : allData && allData.length > 0 ? (
                        allData.map(item => (
                            <tr
                                key={item._id}
                                className='listing_table-row'
                                id='formula_row'
                            >
                                <td
                                    className='listing_table-service_title'
                                    id='service_item'
                                >
                                    {item.title}
                                </td>
                                <td id='service_item' className='category_item'>
                                    {item.category}
                                </td>
                                <td id='service_item' className='price_item'>
                                    {+item.price === 0
                                        ? item.description
                                        : item.price}
                                </td>
                                <td className='button_item'>
                                    <button
                                        className='listing_icons'
                                        id={item._id}
                                        onClick={e => handleClickEdit(e)}
                                    >
                                        <img
                                            src='/patients/edit.svg'
                                            alt='edit-logo'
                                            id={item._id}
                                        />
                                    </button>
                                    <button
                                        className='listing_icons'
                                        id={item._id}
                                        onClick={e => handleClickDelete(e)}
                                    >
                                        <img
                                            src='/patients/delete.svg'
                                            alt='edit-logo'
                                            id={item._id}
                                        />
                                    </button>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={5} className='no-data'>
                                Послуги відсутні
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            {!isLoading && (
                <PatientsPagination
                    localdataLength={dataLength}
                    activepage={activepage}
                    handleChangeActivepage={handleChangeActivepage}
                    limitPage={limitPage}
                />
            )}
        </main>
    );
}
